import React, { Component } from 'react'
import ClampJS from 'clamp-js'
export default class Clamp extends Component {
    componentDidMount() {
        const { clamp } = this.props
        ClampJS(this.refs.container, { clamp })
    }
    componentDidUpdate(prevProps, prevState) {
        this.componentDidMount()
    }
    render() {
        return (
            <div ref="container" style={this.props.style}>
                {this.props.children}
            </div>
        )
    }
}
